import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAreaChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.750034 13.6667V9.5M5.19448 13.6667V6.16667M9.63892 13.6667V9.5M14.0834 13.6667V6.16667M0.75 5.33333L5.19448 0.75L9.63892 5.33333L14.0833 0.75",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAreaChart);
export default ForwardRef;
